import { useEffect, useState } from "react";
import { NAV_LINKS } from "@/lib/content";

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-nav"
            className={`fixed top-0 left-0 right-0 z-50 transition-all duration-700 ${
                scrolled
                    ? "bg-pearl/85 backdrop-blur-md border-b border-cacao/10"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 md:py-6 flex items-center justify-between">
                <a
                    href="#top"
                    data-testid="nav-wordmark"
                    aria-label="Arc & Light — home"
                    className="block leading-none flex-shrink-0"
                >
                    <img
                        src="/logos/arc-light-cacao.png"
                        alt="Arc & Light"
                        width="220"
                        height="14"
                        className="h-[12px] md:h-[13px] w-auto max-w-none select-none block"
                        draggable="false"
                    />
                </a>

                <nav className="hidden md:flex items-center gap-10">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={`nav-link-${l.label.toLowerCase()}`}
                            className="text-cacao text-[0.78rem] tracking-[0.18em] uppercase font-medium hover:text-clay transition-colors duration-500"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <a
                    href="#offer"
                    data-testid="nav-book-cta"
                    className="hidden md:inline-flex btn-clay !py-3 !px-5 !text-[0.7rem]"
                >
                    Book a Consultation
                </a>

                <button
                    type="button"
                    data-testid="nav-menu-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="md:hidden text-cacao p-2"
                    aria-label="Toggle menu"
                >
                    <span className="block w-6 h-px bg-cacao mb-1.5" />
                    <span className="block w-6 h-px bg-cacao mb-1.5" />
                    <span className="block w-4 h-px bg-cacao ml-auto" />
                </button>
            </div>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="md:hidden bg-pearl border-t border-cacao/10 px-6 py-6 flex flex-col gap-5"
                >
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            onClick={() => setOpen(false)}
                            className="text-cacao text-[0.85rem] tracking-[0.18em] uppercase font-medium"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#offer"
                        onClick={() => setOpen(false)}
                        className="btn-clay self-start"
                    >
                        Book a Consultation
                    </a>
                </div>
            )}
        </header>
    );
}
